import {useMutation} from '@tanstack/react-query';
import recruitmentsFetchers from '@/api/fetchers/recruitments/recruitments';
import type {BulkEmailParams} from '@/views/creators/recruit-crm/types';

/**
 * Hook to send bulk emails to multiple recruitments via the CRM bulk emails API.
 *
 * Sends emails to selected recruitments. Emails are queued for asynchronous delivery.
 *
 * @returns React Query mutation for recruitment bulk email sending
 */
function useRecruitmentBulkEmails() {
  return useMutation<unknown, Error, BulkEmailParams>({
    mutationKey: ['recruitments', 'bulkEmails'],
    mutationFn: recruitmentsFetchers.bulkEmails,
  });
}

export default useRecruitmentBulkEmails;
